<template>
  <div class="footer">
    <!--  -->
    <div :class="[
      'mainBody',
    ]">
      <div class="clear f-cont">
        <div class=" fleft">
          <div class="fline colorfff fontsize16">
            <template v-for="(item, index) in navlist">
              <div class="link_list link " v-if="item.key == 'FriendlyLinks'">
                {{ item.text }}:
                <div class="link2" v-for="item2 in item.list">{{ item2.text2 }} <a :href="item2.url" target="_blank">
                    {{ item2.text }}
                  </a></div>

              </div>
              <router-link class="link" :to="item.url" v-else :key="index">
                {{ item.text }}
              </router-link>
            </template>
          </div>
          <div class="fphone ftext">
            <i></i>
            <span>
              电 话：0774-2063353 3811505
              2063293（经营部），3811522（办公室）</span>
          </div>
          <div class="fadress ftext">
            <i></i>
            <span> 地 址：广西梧州市万秀区梧松路1号（扶典）</span>
          </div>
        </div>
        <div class="fright  clear">
          <div class="qrCode fontsize16">
            <div class="qrInfo">
              <span>扫码添加</span>
              <span>梧州黄埔化工视频号</span>
            </div>
            <img src="../../assets/images/common/qrcode.jpg" />
          </div>
        </div>
      </div>
    </div>
    <div class="fbeian fontsize14">
      <a class="fbeian_link" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">
        Copyright 2011 All rights reserved. 桂ICP备11001114号
      </a>
      <div class="fbeian_com">技术支持：广州化工交易中心有限公司</div>
    </div>
  </div>
</template>
<script>
import { Tooltip } from "element-ui";
export default {
  data() {
    return {
      navlist: [
        {
          url: "/",
          text: "首页",
          key: "index",
          tips: "",
        },
        {
          url: "/company",
          text: "关于我们",
          key: "company",
          tips: "",
        },
        {
          url: "/product",
          text: "产品中心",
          key: "product",
          tips: "",
        },
        {
          url: "/news",
          text: "新闻动态",
          key: "news",
          tips: "",
        },
        {
          url: "/recruit",
          text: "人才招聘",
          key: "recruit",
          tips: "",
        },
        {
          url: "/contactus",
          text: "联系我们",
          key: "contactus",
          tips: "",
        },
        {
          url: "",
          text: "友情链接",
          key: "FriendlyLinks",
          list: [
            {
              url: "https://www.giihg.com/",
              text: "广州工控",
              text2: "上级集团:",
              key: "Links1",
              tips: "",
            },
            {
              url: "http://www.wssfc.com/",
              text: "日成林化",
              text2: "下属企业：",
              key: "Links2",
              tips: "",
            },
          ],
          tips: "",
        },
      ],
    };
  },
  computed: {
    currentNav: {
      get() {
        return this.$store.state.currentNav;
      },
      set(val) {
        return this.$store.commit("updateCurrentNav", val);
      },
    },
  },
  components: {
    Tooltip,
  },
};
</script>
<style scoped lang="scss">
.footer {
  width: 100%;
  background: #333;
  padding: 2.6vw 0 1.04vw;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;

  .fline {
    display: flex;
    padding: 0 0 2.08vw 0;
    position: relative;

    .link {
      display: inline-block;
      padding: 0 1.04vw 0 0.42vw;
      border-left: 0.21vw solid #83bb26;

      &:last-child {
        border-right: none;
      }
    }

    .link_list {
      display: flex;
      // width: 15.63vw;
      // padding: 0 2.08vw 0 0.42vw;
      // position: absolute;
      // top: 0;
      // right: -17.6vw;

      .link2 {
        display: flex;
        margin-left: 0.73vw;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .f-cont {
    position: relative;

    .fleft {
      // width: 28.13vw;
      min-height: 8.33vw;

      .ftext {
        height: 1.56vw;
        padding: 0 0 1.04vw 0;
        text-align: left;
        position: relative;

        &.fphone i {
          background: url("../../assets/images/common/phone.png") no-repeat;
          background-size: contain;
        }

        &.fadress i {
          background: url("../../assets/images/common/adress.png") no-repeat;
          background-size: contain;
        }

        i {
          display: inline-block;
          width: 1.25vw;
          height: 1.25vw;
          margin-right: 0.31vw;
          vertical-align: top;
          position: absolute;
          top: 0;
          left: 0;
        }

        span {
          display: inline-block;
          height: 1.56vw;
          line-height: 1.56vw;
          color: #ffffff;
          font-size: 0.83vw;
          padding-left: 1.56vw;
        }
      }

    }

    .fright {
      // width: 14.58vw;
      position: absolute;
      top: 0;
      right: 0;

      .qrCode {
        display: flex;
        justify-content: space-between;
        // width: 18.75vw;
        // margin: 0 1.04vw;
        margin-top: 0.31vw;

        .qrInfo {
          flex: 1;
          padding: 3.13vw 1.04vw 0 0;

          span {
            display: block;
            font-size: 0.83vw;
            line-height: 1.25vw;
            padding: 0 0 1.04vw 0;
            color: #ffffff;
          }
        }

        img {
          // width: 100%;
          display: block;
          flex-shrink: 0;
          width: 6.25vw;
          object-fit: contain;
          padding-top: 0.21vw;
        }
      }
    }
  }

  .fbeian {
    margin-top: 1.04vw;
    position: relative;
    width: 100%;
    text-align: center;

    .fbeian_link {
      display: inline-block;
      color: #fff;
    }

    .fbeian_com {
      display: inline-block;
      color: #fff;
      padding: 0 0 0 1.04vw;
    }
  }
}


@media (min-width: 1920px) {
  .footer {
    width: 100%;
    background: #333;
    padding: 50px 0 20px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;

    .fline {
      display: flex;
      padding: 0 0 40px 0;
      position: relative;

      .link {
        display: inline-block;
        padding: 0 20px 0 8px;
        border-left: 4px solid #83bb26;

        &:last-child {
          border-right: none;
        }
      }

      .link_list {
        display: flex;
        // width: 300px;
        // padding: 0 40px 0 8px;
        // position: absolute;
        // top: 0;
        // right: -338px;

        .link2 {
          display: flex;
          margin-left: 14px;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    .f-cont {
      position: relative;

      .fleft {
        // width: 540px;
        min-height: 160px;

        .ftext {
          height: 30px;
          padding: 0 0 20px 0;
          text-align: left;
          position: relative;

          &.fphone i {
            background: url("../../assets/images/common/phone.png") no-repeat;
            background-size: contain;
          }

          &.fadress i {
            background: url("../../assets/images/common/adress.png") no-repeat;
            background-size: contain;
          }

          i {
            display: inline-block;
            width: 24px;
            height: 24px;
            margin-right: 6px;
            vertical-align: top;
            position: absolute;
            top: 0;
            left: 0;
          }

          span {
            display: inline-block;
            height: 30px;
            line-height: 30px;
            color: #ffffff;
            font-size: 16px;
            padding-left: 30px;
          }
        }

      }

      .fright {
        // width: 280px;
        position: absolute;
        top: 0;
        right: 0;

        .qrCode {
          display: flex;
          justify-content: space-between;
          // width: 360px;
          // margin: 0 20px;
          margin-top: 6px;

          .qrInfo {
            flex: 1;
            padding: 60px 20px 0 0;

            span {
              display: block;
              font-size: 16px;
              line-height: 24px;
              padding: 0 0 20px 0;
              color: #ffffff;
            }
          }

          img {
            // width: 100%;
            display: block;
            flex-shrink: 0;
            width: 120px;
            object-fit: contain;
            padding-top: 4px;
          }
        }
      }
    }

    .fbeian {
      margin-top: 20px;
      position: relative;
      width: 100%;
      text-align: center;

      .fbeian_link {
        display: inline-block;
        color: #fff;
      }

      .fbeian_com {
        display: inline-block;
        color: #fff;
        padding: 0 0 0 20px;
      }
    }
  }

}
</style>
